/* eslint-disable */
import store from '@/vuex/store';
import i18n from '@/locales/i18n';
import currentRepresentationKey from '@/utility/representationKey';

const removeKeycloakStateRegex = /state=[^&]+&session_state=[^&]+&iss=[^&]+&code=[^&]+/g;

const removeHashFromUrl = (hash) =>
  hash
    .split('')
    .filter((char) => char !== '#')
    .join('');

const redirectIsFromKeycloak = (path) =>
  path.includes('state=') && path.includes('session_state=') && path.includes('code=');

const redirectIfRedirectExists = (to, next) => {
  const { fullPath, hash } = to;
  const isKeycloakUrl = redirectIsFromKeycloak(fullPath);
  if (isKeycloakUrl) {
    next(fullPath.replace(removeKeycloakStateRegex, ''));
  } else if (hash !== '') {
    const pathWithoutHash = removeHashFromUrl(fullPath).replace('//', '/');
    next(pathWithoutHash);
  } else {
    next();
  }
};

export const announceNewPageToScreenReaders = (to) => {
  const announcer = document.getElementById('announcer');
  if (!to.name || !announcer) {
    return;
  }
  announcer.innerHTML = `${to.name} has loaded`;
};

const hasValidStoredUser = () => {
  const storedUser = JSON.parse(
    localStorage.getItem(currentRepresentationKey)
  );
  const representationTimeout = 24 * 60 * 60 * 1000; // 24 hours
  return storedUser && storedUser.brukerId && new Date().getTime() - storedUser.lastChanged < representationTimeout;
};

const updateRepresentation = (to) => {
  const brukerinfo = store.state['brukerinfo'];
  if (to.name === 'SelectRepresentation') {
    store.dispatch(
      'representasjoner/setCurrentRepresentation',
      {
        erPrivatPerson: true,
        navn: `${brukerinfo.fornavn} ${brukerinfo.etternavn}`,
        identifikator: brukerinfo.brukerId,
      },
      { root: true }
    );
  }
};

export const guardNavigation = (to, from, next) => {
  const storedUserIsValid = hasValidStoredUser();

  updateRepresentation(to);

  if (storedUserIsValid && store.getters['representasjoner/hasCurrentRepresentation']) {
    redirectIfRedirectExists(to, next);
  } else if (to.name === 'SelectRepresentation') {
    redirectIfRedirectExists(to, next);
  } else {
    next({ name: 'SelectRepresentation' });
  }
};
